(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSocialGalleryVideos() {
      var videos = document.querySelectorAll('video.social-gallery__media--video[autoplay]');
      if (!videos.length || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      videos.forEach(function (v) {
        v.dataset.sgObserved = '1';
        io.observe(v);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSocialGalleryVideos);
    } else {
      initSocialGalleryVideos();
    }
    // Re-init when re-rendered in the theme editor
    document.addEventListener('shopify:section:load', initSocialGalleryVideos);
  })();

  } catch(e) { console.error(e); }
})();
})();
